// extracted by mini-css-extract-plugin
module.exports = {"header":"WorkspacesBox_header__2EZCV","box":"WorkspacesBox_box__3oVw5","node":"WorkspacesBox_node__3ohRk"};